import { DNABox, DNACard } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import React from 'react';
import { StyleSheet } from 'react-native';
import DNARouteTabs from 'src/components/DNA/Navigation/DNARouteTabs/DNARouteTabs';
import { useCurrentUserORM } from 'src/state/redux/selector/user';
import UsersList, { UserActions } from '../Tenants/Tabs/Users';
import IntegrationsList from '../Tenants/Tabs/Integrations';
import { useTenant } from 'src/state/redux/selector/tenant';
import { TitleBar } from 'src/components/DNA';
import useBreakpointValue from 'src/hooks/useBreakpointValue';
import useIsTenantAdmin from 'src/hooks/useIsTenantAdmin';
import useFeatureFlags from 'src/hooks/useFeatureFlags/useFeatureFlags';
import { UserRole } from '@alucio/aws-beacon-amplify/src/models';
import { ROUTES } from 'src/router/routes';

const style = StyleSheet.create({
  mainWrapper: {
    backgroundColor: colors['color-text-white'],
    flex: 1,
    flexDirection: 'column',
    minHeight: 'calc(100vh - 160px)',
    minWidth: 'auto',
    paddingVertical: 24,
  },
  header: {
    marginBottom: 20,
  },
})

const AdminSettings = () => {
  const currentUser = useCurrentUserORM();
  const tenantORM = useTenant(currentUser?.model.tenantId || '');
  const tenantId = currentUser?.model.tenantId || '';
  const horizontalPadding = useBreakpointValue('responsivePadding');
  const isTenantAdmin = useIsTenantAdmin();
  const isPublisherIntegrationAllowed = useFeatureFlags('beac_7469_publisher_run_integration');

  if (!currentUser || !tenantORM) return null;

  // Check if user is a publisher with feature flag access
  const isPublisher = currentUser.model.role === UserRole.TENANT_PUBLISHER;
  const isPublisherWithFeatureFlag = isPublisher && isPublisherIntegrationAllowed;

  // Check if publisher has tenant admin access (in additionalRoles)
  const isPublisherWithAdminAccess = isPublisher &&
    Array.prototype.includes.call(currentUser?.model.additionalRoles ?? [], UserRole.TENANT_ADMIN);

  // Show users tab for tenant admins or publishers with admin access
  const showUsersTab = isTenantAdmin || isPublisherWithAdminAccess;
  // Show integrations tab for both tenant admins and publishers with feature flag
  const showIntegrationsTab = isTenantAdmin || isPublisherWithFeatureFlag;

  return (
    <DNABox style={[style.mainWrapper, { paddingHorizontal: horizontalPadding }]}>
      <DNABox>
        <TitleBar
          title="Settings"
          description={showUsersTab ? 'Manage your users and integrations' : 'Manage your integrations'}
        />
      </DNABox>
      <DNACard appearance="flat">
        <DNARouteTabs.Router>
          <DNARouteTabs.Tabs withDivider>
            {showUsersTab
              ? <DNARouteTabs.Tab title="Users" path={ROUTES.UI2_PUBLISHER_ADMIN_USER.PATH}>
                <DNABox appearance="col" fill >
                  <UserActions tenantId={tenantId} />
                  <UsersList tenantId={tenantId} />
                </DNABox>
              </DNARouteTabs.Tab>
              : <></>}
            {showIntegrationsTab
              ? <DNARouteTabs.Tab title="Integrations" path={ROUTES.UI2_PUBLISHER_ADMIN_INTEGRATION.PATH}>
                <IntegrationsList variant="publisher" selectedTenant={tenantORM} />
              </DNARouteTabs.Tab>
              : <></>}
            <DNARouteTabs.Unmatched
              rewrite={showUsersTab ? '/publisher_admin_user' : '/publisher_admin_integration'}
            />
          </DNARouteTabs.Tabs>
        </DNARouteTabs.Router>
      </DNACard>
    </DNABox>
  )
}

export default AdminSettings;
